import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {VehicleContainerModel} from '../../../../../../models/aggregates/erp/entity';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from '../../shared';



@Injectable({
  providedIn: 'root'
})
export class VehicleService extends BaseApiTemplateService<VehicleContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-vehicle-hdrs/backoffice-ep';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-vehicle-hdrs/backoffice-ep'; 
    this.httpClient = http;
  }

  public createTemp(payload: VehicleContainerModel, apiVisa: ApiVisa) {
    let apiUrl = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-vehicle-hdrs/backoffice-ep/temp';
    return this.httpClient.post<ApiResponseModel<any>>(
        apiUrl,
        payload,
        this.getHttpHeader(apiVisa)
    );
  }
}
